"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARSING_CONTROL_MAP = exports.PARSING_MAP = void 0;
var Staff_1 = require("@cck/common/dist/data/Staff");
var Translation_1 = require("@cck/common/dist/data/Translation");
exports.PARSING_MAP = {
    설계평가: {
        executor: { pos: 'I6', korName: (0, Translation_1.getLevelName)(Staff_1.Level.NORMAL) },
        createDate: { pos: 'I7', korName: '작성일자' },
        considerationContents: [
            { pos: 'G25', korName: '이해내용1' },
            { pos: 'G27', korName: '이해내용2' },
            { pos: 'G29', korName: '이해내용3' }
        ],
        considerationResults: [
            { pos: 'L24', korName: '이해결론1' },
            { pos: 'L26', korName: '이해결론2' },
            { pos: 'L28', korName: '이해내용3' }
        ],
        baselineReference: { pos: 'F33', korName: '설계일자(Baseline) Reference' },
        result: { pos: 'D35', korName: '평가 결론' }
    }
};
exports.PARSING_CONTROL_MAP = {
    processCycleName: -1,
    processCategoryName: -1,
    processSubCategoryName: -1,
    processCode: -1,
    department: -1,
    owner: -1,
    riskNumber: -1,
    riskName: -1,
    id: -1,
    narrative: -1,
    Yes: -1,
    수동통제: -1,
    예방: -1,
    일별수시: -1,
    H: -1,
    M: -1,
    L: -1,
    TOC_TestMethod_InquiryInspection: -1,
    TOC_TestMethod_Observation: -1,
    TOC_TestMethod_Reperformance: -1,
    TOC_Procedure: -1,
    TOC_Evidence: -1,
    MRC_Number: -1,
    IPE_Number: -1 // IPE 번호
};
//# sourceMappingURL=DesignExcelConfigs.js.map